<label>Etapes à afficher</label>
<mat-table #table [dataSource]="stepCustomizations()">
    <!-- Colonne affichant le nom de l'étape -->
    <ng-container matColumnDef="stepName">
        <mat-header-cell *matHeaderCellDef>Nom</mat-header-cell>
        <mat-cell *matCellDef="let element">
            <span>{{ element.stepName }}</span>
        </mat-cell>
    </ng-container>

    <!-- Colonne affichant la visibilité de l'étape -->
    <ng-container matColumnDef="visibility">
        <mat-header-cell *matHeaderCellDef>Visibilité</mat-header-cell>
        <mat-cell *matCellDef="let element">
            <mat-select [(value)]="element.visibilityCondition" placeholder="Visibilité" (selectionChange)="onStepVisibilityChange($event, element.stepId)">
                <mat-option [value]="FolderTrackingStepVisibilityCondition.Always">Toujours</mat-option>
                <mat-option [value]="FolderTrackingStepVisibilityCondition.Never">Jamais</mat-option>
                <mat-option [value]="FolderTrackingStepVisibilityCondition.OnlyIfActivated">Seulement si l'étape est active</mat-option>
                <mat-option [value]="FolderTrackingStepVisibilityCondition.OnlyIfNotInStates">Seulement si l'étape n'est pas dans l'état...</mat-option>
            </mat-select>
        </mat-cell>
    </ng-container>

    <!-- Colonne affichant les états de l'étape -->
    <ng-container matColumnDef="states">
        <mat-header-cell *matHeaderCellDef>Etats</mat-header-cell>
        <mat-cell *matCellDef="let element; let index = index">
            @if (stepStateInputVisibility()[index]) {
                <mat-select [(ngModel)]="element.states" multiple required #stateselect placeholder="selectionner des états...">
                    @for (state of getStepStates(element.stepId); track state.id) {
                        <mat-option [value]="state.id">
                            {{ state.name }}
                        </mat-option>
                    }
                </mat-select>
            }
        </mat-cell>
    </ng-container>

    <!-- Colonne affichant l'icone de l'étape -->
    <ng-container matColumnDef="icon">
        <mat-header-cell *matHeaderCellDef>Icône</mat-header-cell>
        <mat-cell *matCellDef="let element; let index = index">
            <!-- Label dont l'apparence a été modifié pour afficher l'icone d'upload ou l'icone de l'étape -->
            <label
                #uploader
                for="file{{ index }}"
                class="uploader"
                title="Cliquer pour modifier l'icône"
                ondragover="return false;"
                (dragenter)="onDragEnter(uploader)"
                (dragleave)="onDragLeave(uploader)"
                (drop)="onDrop($event, index, uploader)">
                <i class="icon icon-upload"></i>
                @if (icons()[index] && icons()[index].length > 0) {
                    <!-- Affichage de l'icone de l'étape -->
                    <img [src]="icons()[index]" />
                } @else {
                    <!-- Affichage de l'icone d'upload -->
                    <fa-icon class="fa-lg icon" [icon]="uploadIcon" title="Cliquer pour uploader une icône"></fa-icon>
                }
            </label>
            <!-- Input de type file pour uploader un fichier (masqué) -->
            <input #fileInput class="inputfile" type="file" id="file{{ index }}" name="file" accept="image/*" (change)="onInputChange($event, index)" />
            @if (icons()[index] && icons()[index].length > 0) {
                <!-- Bouton pour supprimer l'icone de l'étape-->
                <fa-icon class="fa-lg icon delete-icon" [icon]="deleteIcon" (click)="onRemoveIcon(index, fileInput)" title="Supprimer l'icône"></fa-icon>
            }
        </mat-cell>
    </ng-container>

    <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
    <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
</mat-table>
